// Adapted from: https://github.com/thgreasi/datalist-polyfill
Bingo.ComboBox = {};
Bingo.ComboBox.init = function (selector) {
    $(`input${selector}[list]`).each(function () {
        $(this).parent().addClass('combobox_wrapper');
        const availableTags = $(`#${$(this).attr('list')}`).find('option').map(function () {
            return this.value;
        }).get();
        const parent = $(this).parent();
        $(this).autocomplete({source: availableTags, minLength: 0, appendTo: parent}).focus(function () {
            if ($(this).attr('readonly')) {
                return;
            }
            $(this).autocomplete('search');
        });
        $(this).removeAttr('list'); // prevent two lists to be shown
    });
};
